import React from 'react';
import ReactDOM from 'react-dom/client'; // use 'react-dom/client' for createRoot

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);